import React from "react";
import FormGroup from "./FormGroup";
import Checkbox from "./Checkbox";
import Select from "./Select";
import MultipleCheckbox from "./MultipleCheckbox";

export default function SelectLimitFormGroup({
  error,
  valid = !error,
  help,
  required,
  disabled,
  readOnly,
  wrapperClassName,
  label,
  value,
  onFocus,
  onBlur,
  onChange,
  options,
  initialSelectedValues = options.map(([v, _]) => v),
  type = "Select",
  inline = true,
}) {
  const checkbox = (
    <Checkbox
      checked={value === null}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(checked) => onChange(checked ? null : initialSelectedValues)}
      label={label}
      required={required}
      disabled={disabled}
      readOnly={readOnly}
      toggle
    />
  );

  if (type === "Select") {
    return (
      <FormGroup error={error} valid={valid} required={required} className={wrapperClassName} inline={inline}>
        <div className={inline ? "fields inline" : "fields grouped"}>
          {checkbox}
          <div
            style={
              inline
                ? { visibility: value === null ? "hidden" : undefined }
                : { display: value === null ? "none" : undefined }
            }
            className={inline ? "u-displayInlineBlock u-marginLeft" : "u-marginTop"}
          >
            <Select
              value={value || []}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onChange}
              options={options}
              required={required}
              disabled={disabled}
              readOnly={readOnly}
              inline
              multiple
              selection
            />
          </div>
        </div>
        {!!help && <div className="ui help">{help}</div>}
      </FormGroup>
    );
  }

  if (type === "NativeSelect") {
    return (
      <FormGroup error={error} valid={valid} required={required} className={wrapperClassName} inline={inline}>
        <div className={inline ? "fields inline" : "fields grouped"}>
          {checkbox}
          <div
            style={
              inline
                ? { visibility: value === null ? "hidden" : undefined }
                : { display: value === null ? "none" : undefined }
            }
            className={inline ? "u-displayInlineBlock u-marginLeft" : "u-marginTop"}
          >
            <select
              multiple
              value={value || []}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={(event) => onChange(event.target.value)}
              required={required}
              disabled={disabled}
              readOnly={readOnly}
            >
              {options.map((option) => (
                <option value={option[0]}>{option[1]}</option>
              ))}
            </select>
          </div>
        </div>
        {!!help && <div className="ui help">{help}</div>}
      </FormGroup>
    );
  }

  if (type === "MultipleCheckbox") {
    const checkboxWrapperStyle = {
      marginTop: "1em",
      marginLeft: "1em",
      marginBottom: "-1em",
    };
    return (
      <FormGroup error={error} valid={valid} required={required} className={wrapperClassName}>
        {checkbox}
        <div hidden={value === null} style={checkboxWrapperStyle}>
          <MultipleCheckbox
            value={value || []}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            options={options}
            required={required ? value.length === 0 : undefined}
            disabled={disabled}
            readOnly={readOnly}
            grouped
          />
        </div>
        {!!help && <div className="ui help">{help}</div>}
      </FormGroup>
    );
  }

  throw new Error("Unknown type prop");
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/SelectLimitFormGroup.jsx